(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Carry the ad's query string (UTMs, fbclid) onto every product link, so
    // the product page sees the same campaign the visitor arrived with.
    var params = new URLSearchParams(window.location.search);
    if ([...params.keys()].length) {
      document.querySelectorAll('a[data-adv-cta]').forEach(function (link) {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        params.forEach(function (value, key) {
          if (!url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        link.setAttribute('href', url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.href);
      });
    }

    // The sticky button appears after a short scroll, so it never covers the
    // hero on the first screen, and then stays on for the rest of the page.
    var sticky = document.querySelector('.adv-sticky');
    if (sticky) {
      var onScroll = function () {
        sticky.classList.toggle('is-visible', window.scrollY > 120);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Loops play only while near the screen: below-the-fold ones fetch nothing
    // until then (posters included, see advertorial-media), and any loop pauses
    // once scrolled away.
    var loops = document.querySelectorAll('video[data-adv-loop]');
    var lazyPosters = document.querySelectorAll('video[data-poster]');
    var setPoster = function (video) {
      if (video.dataset.poster) {
        video.poster = video.dataset.poster;
        video.removeAttribute('data-poster');
      }
    };
    if ('IntersectionObserver' in window) {
      var posterObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setPoster(entry.target);
              posterObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '1500px 0px' }
      );
      lazyPosters.forEach(function (video) {
        posterObserver.observe(video);
      });
    } else {
      lazyPosters.forEach(setPoster);
    }
    if (loops.length) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        loops.forEach(function (video) {
          video.pause();
        });
      } else if ('IntersectionObserver' in window) {
        var loopObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var playing = entry.target.play();
                if (playing) playing.catch(function () {});
              } else {
                entry.target.pause();
              }
            });
          },
          { rootMargin: '300px 0px' }
        );
        loops.forEach(function (video) {
          loopObserver.observe(video);
        });
      } else {
        loops.forEach(function (video) {
          var playing = video.play();
          if (playing) playing.catch(function () {});
        });
      }
    }

    document.querySelectorAll('.adv-reviews--carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.adv-carousel__track');
      var dots = carousel.querySelector('.adv-carousel__dots');
      if (!track || !dots) return;
      var slides = track.children;
      if (!slides.length) return;
      for (var i = 0; i < slides.length; i++) dots.appendChild(document.createElement('span'));
      var current = 0;
      function show(index) {
        current = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        for (var j = 0; j < dots.children.length; j++) dots.children[j].classList.toggle('is-active', j === current);
      }
      show(0);
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (slides.length > 1 && !reduceMotion) setInterval(function () { show(current + 1); }, 5000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
